/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Buduje ciezka mape losowan z malego kontraktu JSON. Obliczenia i kolejnosc
   pochodza z PHP; przegladarka tworzy tylko semantyczna tabele. */
(function (doc) {
    'use strict';
    var map = doc.querySelector('[data-ra-map]');
    if (!map) return;
    var table = map.querySelector('[data-ra-map-table]');
    var source = map.querySelector('[data-ra-map-data]');
    var head = table && table.querySelector('[data-ra-map-head]');
    var body = table && table.querySelector('[data-ra-map-body]');
    if (!table || !source || !head || !body) return;

    var en = /^en(?:-|$)/i.test(doc.documentElement.lang || '');
    var data;
    try { data = JSON.parse(source.textContent || '{}'); }
    catch (error) { data = null; }
    var columns = data && Array.isArray(data.kolejnosc) ? data.kolejnosc : [];
    var rows = data && Array.isArray(data.wiersze) ? data.wiersze : [];
    if (!columns.length || columns.length > 100 || rows.length > 500) {
        var status = map.querySelector('[data-ra-map-message]');
        if (status) status.textContent = jst("pages_rozbudowa_mapa_js.d9bd7571e2c3");
        return;
    }

    var game = table.getAttribute('data-gra') || 'lotto';
    var resultPattern = table.getAttribute('data-wynik-wzor') || '';
    var locale = jst("pages_rozbudowa_mapa_js.5e0c5bd590a9");
    var displayDate = new Intl.DateTimeFormat(locale, {
        timeZone: 'Europe/Warsaw', day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: false
    });
    var routeDate = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit'
    });
    function safeNumber(value, max) {
        var n = Number(value);
        return Number.isInteger(n) && n >= 1 && n <= max ? n : null;
    }
    function datePart(value) {
        var parts = routeDate.formatToParts(new Date(value)), out = {};
        parts.forEach(function (part) { if (part.type !== 'literal') out[part.type] = part.value; });
        return out.year && out.month && out.day ? out.year + '-' + out.month + '-' + out.day : '';
    }
    function ball(number) {
        var wrap = doc.createElement('div');
        wrap.className = 'kula-z-podpisem';
        var span = doc.createElement('span');
        span.className = 'kula kula--mala kula--' + game;
        span.textContent = String(number);
        span.setAttribute('aria-label', (jst("pages_rozbudowa_mapa_js.4eab95088fd1")) + number);
        wrap.appendChild(span);
        return wrap;
    }

    var cleanColumns = columns.map(function (value) { return safeNumber(value, 100); }).filter(function (value) { return value !== null; });
    if (cleanColumns.length !== columns.length) return;
    var headFragment = doc.createDocumentFragment();
    cleanColumns.forEach(function (number) {
        var th = doc.createElement('th');
        th.scope = 'col';
        th.setAttribute('data-ra-column', String(number));
        th.appendChild(ball(number));
        var count = doc.createElement('span');
        count.className = 'tekst-maly';
        count.textContent = String((data.counts && data.counts[number]) || 0);
        th.appendChild(count);
        headFragment.appendChild(th);
    });
    head.appendChild(headFragment);

    var bodyFragment = doc.createDocumentFragment();
    rows.forEach(function (row) {
        if (!row || !Array.isArray(row.numbers)) return;
        var when = new Date(row.drawn_at || '');
        if (Number.isNaN(when.getTime())) return;
        var drawn = new Set(row.numbers.map(Number));
        var tr = doc.createElement('tr');
        var th = doc.createElement('th');
        th.scope = 'row';
        var link = doc.createElement('a');
        var day = datePart(row.drawn_at);
        link.href = day && resultPattern ? resultPattern.replace('__DATE__', day) : '#';
        link.textContent = displayDate.format(when).replace(',', '');
        th.appendChild(link);
        var id = doc.createElement('small');
        var publicNumber = Object.prototype.hasOwnProperty.call(row, 'public_number') ? row.public_number : (row.draw_system_id ?? row.legacy_id);
        id.textContent = '#' + String(publicNumber || '—');
        th.appendChild(id);
        tr.appendChild(th);
        cleanColumns.forEach(function (number) {
            var hit = drawn.has(number), td = doc.createElement('td');
            td.setAttribute('data-ra-column', String(number));
            var pattern = doc.createElement('span');
            pattern.className = 'rytm-wzor rytm-wzor--' + game;
            pattern.setAttribute('role', 'img');
            pattern.setAttribute('aria-label', number + ': ' + (hit ? (jst("pages_rozbudowa_mapa_js.e611703abe30")) : (jst("pages_rozbudowa_mapa_js.c6c0dd8ed826"))));
            var bit = doc.createElement('span');
            bit.className = 'rytm-bit rytm-bit--' + (hit ? '1' : '0');
            bit.setAttribute('aria-hidden', 'true');
            pattern.appendChild(bit); td.appendChild(pattern); tr.appendChild(td);
        });
        bodyFragment.appendChild(tr);
    });
    body.appendChild(bodyFragment);
    table.setAttribute('data-ra-map-ready', '1');
})(document);
